import {LoaderState} from '@store/loader/loader.state';
import {Selector} from '@ngxs/store';
import {LoaderStateModel} from '@store/loader/loader-state.model';

export class LoaderSelectors {
  @Selector([LoaderState])
  static getDeviceLoader(state: LoaderStateModel): boolean {
    return state.deviceLoader;
  }

  @Selector([LoaderState])
  static getUnapprovedLoader(state: LoaderStateModel): boolean {
    return state.unapprovedLoader;
  }

  @Selector([LoaderState])
  static getGroupsLoader(state: LoaderStateModel): boolean {
    return state.groupsLoader;
  }

  @Selector([LoaderState])
  static getMediaLoader(state: LoaderStateModel): boolean {
    return state.mediaLoader;
  }

  @Selector([LoaderState])
  static getPlaylistLoader(state: LoaderStateModel): boolean {
    return state.playlistLoader;
  }

  @Selector([LoaderState])
  static getScheduleLoader(state: LoaderStateModel): boolean {
    return state.scheduleLoader;
  }

  @Selector([LoaderState])
  static getGlobalLoader(state: LoaderStateModel): boolean {
    return state.globalLoader;
  }

  @Selector([LoaderState])
  static getMetricsLoader(state: LoaderStateModel): boolean {
    return state.metricsLoader;
  }

  @Selector([LoaderState])
  static getOfflineDevicesSummaryLoader(state: LoaderStateModel): boolean {
    return state.offlineDevicesSummaryLoader;
  }

  @Selector([LoaderState])
  static getUngroupedDevicesLoader(state: LoaderStateModel): boolean {
    return state.ungroupedDevicesLoader;
  }

  @Selector([LoaderState])
  static getGroupedDevicesLoader(state: LoaderStateModel): boolean {
    return state.groupedDevicesLoader;
  }

  @Selector([LoaderState])
  static getScheduledGroupsLoader(state: LoaderStateModel): boolean {
    return state.scheduledGroupsLoader;
  }

  @Selector([LoaderState])
  static getScheduledDevicesLoader(state: LoaderStateModel): boolean {
    return state.scheduledDevicesLoader;
  }

  @Selector([LoaderState])
  static getRssLoader(state: LoaderStateModel): boolean {
    return state.rssLoader;
  }

  @Selector([LoaderState])
  static getSettingsLoader(state: LoaderStateModel): boolean {
    return state.settingsLoader;
  }
}
